<template>
  <AuthBody/>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import AuthBody from '@/components/AuthBody.vue'; 

export default defineComponent({
  name: 'AuthView',
  components: {
    AuthBody,
  },
});
</script>
